import React from 'react';
import { Card } from 'react-bootstrap';

function TotalOrders() {
  return (
    <Card className="mb-4">
      <Card.Body>
        <h5>Total Orders</h5>
        <h2>75</h2>
      </Card.Body>
    </Card>
  );
}

export default TotalOrders;
